import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { GlobalContext } from "../context/GlobalContext";

// loads the domain dropdown options: [{ label, value }]
export default function useDomains() {
  const { API_URL, showToast } = useContext(GlobalContext);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const response = await axios.get(`${API_URL}/filterDomain`);
        if (!cancelled) {
          setOptions(response.data.map((x) => ({ label: x.domain, value: x.domain })));
        }
      } catch (err) {
        console.log(err);
        showToast("error", "Failed to load domains", "top", 5);
        if (!cancelled) setOptions([]);
      }
    })();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line
  }, []);

  return options;
}
